// extracted by mini-css-extract-plugin
export var errorIcon = "_lz-1";
export var nameLogo = "_lz-0";